// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5350":"971a56c52608d6b8","5862":"40f4d27f070504dd","7556":"0b883df539402267","9185":"66ada6e98278e696"}[chunkId] + ".css";
};